import { format, toZonedTime } from "date-fns-tz";
import dayjs, { type Dayjs } from "dayjs";

const timeZone = "America/Chicago"; // CST/CDT Timezone

export const getTimeDifference = (startDate: Date, endDate: Date) => {
  try {
    const start = startDate.getTime();
    const end = endDate.getTime();
    const diffInMinutes = Math.abs(Math.trunc((end - start) / (1000 * 60)));

    if (diffInMinutes >= 60) {
      const hours = Math.trunc(diffInMinutes / 60);
      const remainingMinutes = diffInMinutes % 60;
      return remainingMinutes === 0
        ? `${hours} hrs`
        : `${hours} hrs ${remainingMinutes} mins`;
    }
    return `${diffInMinutes} mins`;
  } catch {
    return "N/A";
  }
};

export const formatDate = (date: string | Date) => {
  try {
    const zonedDate = toZonedTime(date, timeZone);
    return format(zonedDate, "MM/dd/yyyy HH:mm");
  } catch {
    return "";
  }
};

export const formatDateShort = (date: string | Date) => {
  try {
    const zonedDate = toZonedTime(date, timeZone);
    return format(zonedDate, "MM/dd HH:mm");
  } catch {
    return "";
  }
};

export const getReadableDateTime = (date: string) => {
  try {
    const dateObj = toZonedTime(new Date(date), timeZone);
    const dayName = format(dateObj, "EEE", { timeZone }); // Short weekday (e.g., "Mon")
    const day = format(dateObj, "d", { timeZone }); // Numeric day
    const ordinal = getOrdinalSuffix(parseInt(day, 10)); // Get ordinal suffix
    return `${dayName} ${day}${ordinal}`; // Combine the parts
  } catch {
    return "N/A";
  }
};

function getOrdinalSuffix(day: number) {
  if (day >= 11 && day <= 13) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

export const isDayTime = (date: string) => {
  try {
    const hours = toZonedTime(date, timeZone).getHours();
    return hours >= 6 && hours < 18;
  } catch {
    return false;
  }
};

export const getHourDiffernce = (startDate: string, endDate: string) => {
  try {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    const diffMs: number = Math.abs(date2.getTime() - date1.getTime());
    const diffHours: number = diffMs / (1000 * 60 * 60);
    return diffHours;
  } catch {
    return 0;
  }
};

export const monthsFormateDate = (dateString: string) => {
  // Validate input
  if (!dateString || Number.isNaN(new Date(dateString).getTime())) return "";
  try {
    const date = new Date(dateString);
    const zonedDate = new Date(toZonedTime(date, timeZone));
    return format(zonedDate, "MMM dd, yyyy, hh:mm a");
  } catch {
    return "";
  }
};

export const formatDateRange = (start: Dayjs | null) => {
  console.log("formatDateRange");
  try {
    return start ? dayjs(start).format("YYYY-MM-DD") : null;
  } catch {
    return "";
  }
};
